import { create } from 'zustand'
import type { Address } from '../types/user'
import type { DeliverySlot } from '../types/order'

interface CheckoutStore {
  // Selected options
  selectedAddress: Address | null
  selectedSlot: DeliverySlot | null
  paymentMethod: string
  orderNotes: string

  // Guest checkout info
  guestName: string
  guestEmail: string
  guestPhone: string

  // Actions
  setSelectedAddress: (address: Address | null) => void
  setSelectedSlot: (slot: DeliverySlot | null) => void
  setPaymentMethod: (method: string) => void
  setOrderNotes: (notes: string) => void
  setGuestInfo: (name: string, email: string, phone: string) => void
  reset: () => void
}

// Generate mock delivery slots
export const generateDeliverySlots = (): DeliverySlot[] => {
  const slots: DeliverySlot[] = []
  const today = new Date()

  for (let day = 0; day < 7; day++) {
    const date = new Date(today)
    date.setDate(date.getDate() + day)
    const dateStr = date.toISOString().split('T')[0]

    const timeSlots = [
      { start: '09:00', end: '12:00', label: 'Morning (9 AM - 12 PM)' },
      { start: '12:00', end: '15:00', label: 'Afternoon (12 PM - 3 PM)' },
      { start: '15:00', end: '18:00', label: 'Evening (3 PM - 6 PM)' },
      { start: '18:00', end: '21:00', label: 'Night (6 PM - 9 PM)' },
    ]

    timeSlots.forEach((time, idx) => {
      // First slot of today might not be available if it's past that time
      const isAvailable = day > 0 || idx > 0

      slots.push({
        id: `${dateStr}-${idx}`,
        date: dateStr,
        time_start: time.start,
        time_end: time.end,
        label: time.label,
        is_available: isAvailable,
      })
    })
  }

  return slots
}

export const useCheckoutStore = create<CheckoutStore>((set) => ({
  selectedAddress: null,
  selectedSlot: null,
  paymentMethod: 'cod',
  orderNotes: '',
  guestName: '',
  guestEmail: '',
  guestPhone: '',

  setSelectedAddress: (address) => set({ selectedAddress: address }),
  setSelectedSlot: (slot) => set({ selectedSlot: slot }),
  setPaymentMethod: (method) => set({ paymentMethod: method }),
  setOrderNotes: (notes) => set({ orderNotes: notes }),

  setGuestInfo: (name, email, phone) =>
    set({
      guestName: name,
      guestEmail: email,
      guestPhone: phone,
    }),

  reset: () =>
    set({
      selectedAddress: null,
      selectedSlot: null,
      paymentMethod: 'cod',
      orderNotes: '',
      guestName: '',
      guestEmail: '',
      guestPhone: '',
    }),
}))
